import { Collection } from 'modules/core/lib/mobx-rest'

import Invitation from 'modules/employees/store/models/Invitation'

class Invitations extends Collection<Invitation> {
  get cacheKey(): string {
    return 'invitations'
  }

  model() {
    return Invitation
  }
}

const singleton: Invitations = new Invitations()

export default singleton
